import type { PlanDayV2, TopicProgressV2 } from './types'
import { nextRep, seedTopic, todayISO } from './spacing'

const ATTEMPT_KEY = 'dk-sp-quiz-attempts'

export interface SpacingCompletion {
  block_idx: number
  mins: number
}

export function claimQuizAttempt(attemptId: number): boolean {
  try {
    const raw = sessionStorage.getItem(ATTEMPT_KEY)
    const list: number[] = raw ? JSON.parse(raw) : []
    if (list.includes(attemptId)) return false
    sessionStorage.setItem(ATTEMPT_KEY, JSON.stringify([...list, attemptId].slice(-200)))
    return true
  } catch {
    return true
  }
}

export function quizSpacingRow(
  topicName: string | null,
  score: number,
  rows: TopicProgressV2[]
): Partial<TopicProgressV2> | null {
  if (!topicName || typeof score !== 'number' || !Number.isFinite(score)) return null
  const existing = rows.find((r) => r.topic_key === topicName)
  const base = existing ?? seedTopic(topicName)
  return { topic_key: topicName, ...nextRep(base, score), last_done_at: todayISO() }
}

export function denemeSpacingRows(
  nets: Record<string, number>,
  date: string,
  rows: TopicProgressV2[]
): Partial<TopicProgressV2>[] {
  return Object.keys(nets)
    .filter((s) => typeof nets[s] === 'number' && Number.isFinite(nets[s]))
    .map((subject) => {
      const existing = rows.find((r) => r.topic_key === subject)
      if (existing) {
        return { topic_key: subject, state: existing.state, misses: existing.misses, last_done_at: date }
      }
      return { topic_key: subject, ...seedTopic(subject), last_done_at: date }
    })
}

export function planDayForDate(plan: unknown, date: string): PlanDayV2 | null {
  if (!plan || typeof plan !== 'object') return null
  const week = (plan as { week?: unknown }).week
  if (!Array.isArray(week)) return null
  const day = week.find((d) => (d as PlanDayV2).date === date) as PlanDayV2 | undefined
  return day && Array.isArray(day.blocks) ? day : null
}

export function coreDayComplete(day: PlanDayV2 | null, completions: SpacingCompletion[]): boolean {
  if (!day) return false
  const done = new Set(completions.filter((c) => c.mins > 0).map((c) => c.block_idx))
  const coreIdx = day.blocks.map((b, i) => (b.core ? i : -1)).filter((i) => i >= 0)
  if (coreIdx.length === 0) return false
  return coreIdx.every((i) => done.has(i))
}
